import type { Employment } from "@oysterhr/schema"

export const getIsHourlySalary = (employment?: Pick<Employment, "hourlyRate"> | null) => {
  return !!employment?.hourlyRate
}
